import { useState, Key, useEffect } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import useGlobalModel from '@/model/globalModel'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { IMaterialDetail, IMaterialSearchFields, materialService } from '../../../../base/material/materialService'
import { IPurchasePoFields, IDetailList } from '../../purchasePoType'
import { IVRMshelfDetail } from '@/views/base/warehouse/warehouseTypes'
import { purchasePoService } from '../../purchasePoService'
import { ISearchPage } from '@/types/ScmTypes'
import { transPgToPagination, formatNum, IsUseDefaultBentity, bigNumber } from '@/utils/utils'
import { globalPrompt } from '@/components/message'
import { DictCodeEnmu, sourceAppOrBranch } from '@/types/VrmSaDictEnums'
import { convertRes2Blob } from '@/utils/exportFile'
import { ISaleSoFields } from '@/views/sale/so/saleSoTypes'
import { saleSoService } from '@/views/sale/so/saleSoService'
import { IStockStatisticDetail } from '@/views/stock/statistic/stockStatisticService'
import { useLockFn } from 'ahooks'
import { message } from 'antd'
import { warehouseService } from "@/views/base/warehouse/warehouseService";
export type IVrmPlanDescType = {
    numAll: number
    itemNumAll: number
    totalAll: number
    [key: string]: any
}
//这里为了继承一个弹框列表的自定义属性值
export interface IMaterialDetailModel extends IMaterialDetail {
    num: number
    amount: number
    confirmNum?: number // 0,
    damageNum?: number // 0,
    // unarrivedNum?: number,    // 0,
}
export const usePurchasePoDetailsModel = createModel(function () {
    const { user, shopAndOrg, beShopDs } = useGlobalModel()
    const { shopId, shopName } = shopAndOrg
    const [addModalVisible, setAddModalVisible] = useState<boolean>(false) //新增商品弹框
    const [settleVisible, setSettleVisible] = useState<boolean>(false) //结算弹框
    const [changeSaleDrawer, serChangeSaleDrawer] = useState<boolean>(false) //转销售单弹框
    const [wsConfirmModal, setWsConfirmModal] = useState<boolean>(false) //库房确认弹框
    const [registerModal, setRegisterModal] = useState<boolean>(false) //入库登记弹框
    const { warehouseList, user: { roles } } = useGlobalModel();
    const [warehouseData, setWarehouseData] = useState<any>({
        add: warehouseList,
        edit: [],
        look: []
    });
    const initDesc = {
        numAll: 0, //数量
        itemNumAll: 0, //项数
        totalAll: 0, //总计
    }
    const initForm = {
        shopId,
        shopName,
        // bentityCode: IsUseDefaultBentity(shopId) ? DictCodeEnmu.BENTITY_BJ_YH_AUTO_SERVICE : '',
        // bentityName: IsUseDefaultBentity(shopId) ? beShopDs.find((item) => item.value === DictCodeEnmu.BENTITY_BJ_YH_AUTO_SERVICE)?.label : '',
        bentityName: beShopDs.find((item: any) => item.value === "bentity.hd")?.label ?? "",
        bentityCode: "bentity.hd",
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: IMaterialSearchFields = {}
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IPurchasePoFields>(initForm)
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([])
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([])
    const [addDesc, setAddDesc] = useState<IVrmPlanDescType>(initDesc)

    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IPurchasePoFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    const [lookDesc, setLookDesc] = useState<IVrmPlanDescType>(initDesc)

    //详情数据
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([])
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([])
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([])
    const [detailEditForm, setDetailEditForm] = useState<IPurchasePoFields>({})
    const [editDesc, setEditDesc] = useState<IVrmPlanDescType>(initDesc)

    //配件列表配置
    const [workDataSource, setWorkDataSource] = useState<IMaterialDetailModel[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IMaterialSearchFields>(initSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<IMaterialDetailModel[]>([])
    //表单改变或表格数据发生改变时，控制功能按钮的启用禁用
    const [topButsControl, setTopButsControl] = useState<boolean>(false)
    const [saveLoading, setSaveLoading] = useState<boolean>(false) //  保存按钮
    //添加临时货位弹框
    const [addTempShelfModal, setAddTempShelfModal] = useState<boolean>(false)
    const typeForm: any = {
        add: { ...detailAddForm },
        edit: detailEditForm,
        look: detailLookForm
    }
    //设置底部总数展示（查看|编辑|查看）
    useEffect(() => {
        let newDesc: IVrmPlanDescType = { ...initDesc }
        detailDataSource &&
            detailDataSource.forEach((item) => {
                newDesc.numAll += Number(item.num)
                // newDesc.totalAll += Number(item.price) * Number(item.num)
                newDesc.totalAll += +bigNumber.toFixed(+bigNumber.times(Number(item.price), Number(item.num)), 2);
            })
        newDesc.itemNumAll = detailDataSource && detailDataSource.length
        setEditDesc(newDesc)
    }, [detailDataSource])

    useEffect(() => {
        let newDesc: IVrmPlanDescType = { ...initDesc }
        detailAddList &&
            detailAddList.forEach((item) => {
                newDesc.numAll += Number(item.num)
                // newDesc.totalAll += Number(item.num) * Number(item.price)
                newDesc.totalAll += +bigNumber.toFixed(+bigNumber.times(Number(item.price), Number(item.num)), 2);
            })
        newDesc.itemNumAll = detailAddList && detailAddList.length
        setAddDesc(newDesc)
    }, [detailAddList])

    useEffect(() => {
        let newDesc: IVrmPlanDescType = { ...initDesc }
        detailLookList &&
            detailLookList.forEach((item) => {
                newDesc.numAll += Number(item.num)
                // newDesc.totalAll += Number(item.num) * Number(item.price)
                newDesc.totalAll += +bigNumber.times(Number(item.price), Number(item.num)).toFixed(2);
            })
        newDesc.itemNumAll = detailLookList && detailLookList.length
        setLookDesc(newDesc)
    }, [detailLookList])
    useEffect(() => {
        setDetailAddForm({ ...initForm, shopId, shopName });
    }, [shopId])
    //新增表单缓存
    const updateAddFormVal = (val: IPurchasePoFields) => {
        let newVal = val
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: IPurchasePoFields) => {
        let newVal = val
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await purchasePoService.one(id)
        // return console.log(retData)
        const { details, settleDetails, ...from } = retData
        if (retData) {
            let fileList: any = [],
                cashFileList: any = []
            const { md5, fileName } = from

            if (md5) {
                fileList = [
                    {
                        uid: md5,
                        status: 'done',
                        name: fileName,
                        response: {
                            retData: md5,
                        },
                    },
                ]
            }
            if (settleDetails && settleDetails.length > 0) {
                const { cashAttach, cashAttachFileName } = settleDetails[0]
                cashFileList = [
                    {
                        uid: cashAttach,
                        status: 'done',
                        name: cashAttachFileName,
                        response: {
                            retData: cashAttach,
                        },
                    },
                ]
            }
            const params = {
                pageSize: 10000,
                pageNum: 1,
                shopId: from.shopId,
            }
            let { retData } = await warehouseService.page(params);
            const { records, ...pg } = retData;
            from.fileList = fileList
            from.cashFileList = cashFileList
            let newList: any = details ? details.map((item) => { return { ...item, detailsId: item.id } }) : []
            if (pattern === 'edit') {
                setWarehouseData({ ...warehouseData, edit: records })
                setDetailDataSource(newList ?? [])
                setDetailEditForm(from)
                setTopButsControl(false)
            } else if (pattern === 'look') {
                setWarehouseData({ ...warehouseData, look: records })
                setDetailLookForm({ ...from, cashName: settleDetails?.[0]?.payMethodName })
                setDetailLookList(newList ?? [])
            }
        }
    }
    //关闭弹框
    const resetWorkloadData = async () => {
        setSearchWorkData({})
        workloadData(initPgCfg, {})
    }
    const [addLoading, setAddLoading] = useState<boolean>(false)
    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: IMaterialSearchFields = searchWorkData) => {
        setAddLoading(true)
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await materialService.page(searchParams)
        const { records, ...pg } = retData
        const newRecords = records.map((item) => {
            let { latestPurPrice, purchasePrice, materialDetal, materialShelfVo } = item
            let materialOne = (materialDetal ?? [])[0]
            materialShelfVo = materialShelfVo ?? {}
            //取最近采购价格，没有的话取档案进货价
            // let newPurchasePrice = latestPurPrice ? latestPurPrice : purchasePrice ?? 0
            let newPurchasePrice = purchasePrice ?? 0
            return {
                ...item,
                num: 1,
                purchasePrice: newPurchasePrice,
                amount: newPurchasePrice * 1,
                warehouseCode: '',
                warehouseName: '',
                shelfCode: '',
                shelfId: '',
            }
        })
        setWorkPgCfg(transPgToPagination(pg))
        setWorkDataSource(newRecords)
        setAddLoading(false)
    }
    //筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: IMaterialDetailModel[], detailList: IDetailList[], mode: string, type: string) => {
        const repetition: string[] = []
        const newDetailData: any[] = [...detailList]
        const detailForm: any = mode === "add" ? detailAddForm : mode === "edit" ? detailEditForm : detailLookForm;
        let newData = type == 'add' ? await transferwarehouseList(modelList, detailForm.purchaseTypeCode, mode) : []
        modelList.forEach((Item) => {
            let isSelect = newDetailData.find((item) => item.materialCode === (Item.materialCode ?? Item.code))
            if (isSelect === undefined) {
                let data = newData.find((list: any) => list.materialCode === (Item.materialCode ?? Item.code))
                newDetailData.push({
                    ...data,
                    ...Item,
                    confirmNum: 0,
                    damageNum: 0,
                    materialCode: Item.materialCode ?? Item.code,
                    price: Item.purchasePrice ?? Item.price,
                    detailsId: Item?.id,
                    id: '',
                    materialName: Item.materialName ?? Item.name,
                })
            } else {
                repetition.push(`【${Item.materialName ?? Item.name} (${Item.materialCode ?? Item.code})】`)
            }
        })
        return { newDetailData, repetition }
    }
    //添加到详情列表
    const transformsToPoDetailList = async (mode: string) => {
        //添加列表
        if (mode === 'add') {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailAddList, mode, 'add')
            setDetailAddList(newDetailData)
            repetition.length != 0 && globalPrompt('message', { text: `${repetition.join(',')}，以上重复配件已过滤。`, type: 'warning' })
        } else if (mode === 'edit') {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailDataSource, mode, 'add')
            setDetailDataSource(newDetailData)
            repetition.length != 0 && globalPrompt('message', { text: `${repetition.join(',')}，以上重复配件已过滤。`, type: 'warning' })
        }
    }
    //添加到详情列表
    const transferwarehouseList = async (list: any, value: string, mode: string,) => {
        const repetition = list.map((item: any) => item.materialCode ?? item.code);
        let { retData } = await purchasePoService.findTransferwarehouse({
            shopId: typeForm[mode].shopId,
            materialCodes: repetition,
            direct: value
        });
        return list.map((item: any) => {
            let newData = retData.find((list: any) => list.materialCode === (item.materialCode ?? item.code))
            return {
                ...item,
                ...newData,
                shelfCode: newData?.shelfCode ?? '',
                shelfId: newData?.shelfId ?? '',
                warehouseCode: newData?.warehouseCode ?? '',
                warehouseName: newData?.warehouseName ?? '',
                isPurShelf: newData?.warehouseCode ? true : false
            }
        })
    }
    //删除详情列表数据
    const detailDetailList = async (mode: string, Material?: IDetailList) => {
        setTopButsControl(true)
        if (mode === 'add') {
            // const filterDetailList = detailAddList.filter(el => !!!detaiAddDataRowKeys.find(ele => ele === el.materialCode));
            const filterDetailList = Material
                ? detailAddList.filter((el) => !!!(Material.detailsId === el.detailsId))
                : detailAddList.filter((el) => !!!detaiAddDataRowKeys.find((ele) => ele === el.detailsId))
            setDetailAddList(filterDetailList)
            globalPrompt('message', { text: `删除成功`, type: 'success' })
            setDetaiAddDataRowKeys([])
            setDetaiAddDataRow([])
        } else if (mode === 'edit') {
            const backendDetailList: any = Material
                ? Material.id
                    ? [{ id: Material.id }]
                    : []
                : detailDataRow.reduce((all, next) => {
                    //前端页面维护的需要删除的id
                    if (next.id) {
                        all.push({ id: next.id })
                    }
                    return all
                }, [])

            //删除详情列表调用的方法
            const deleteData = () => {
                // const filterDetailList = detailDataSource.filter(el => !!!detailDataRowKeys.find(ele => ele === el.materialCode))
                const filterDetailList = Material
                    ? detailDataSource.filter((el) => !!!(Material.detailsId === el.detailsId))
                    : detailDataSource.filter((el) => !!!detailDataRowKeys.find((ele) => ele === el.detailsId))
                setDetailDataSource(filterDetailList)
                globalPrompt('message', { text: `删除成功`, type: 'success' })
                setDetailDataRowKeys([])
                setDetailDataRow([])
            }

            if (backendDetailList.length > 0) {
                await purchasePoService.materialDelete({ ids: backendDetailList, purchaseCode: detailEditForm.purchaseCode as string }).then((res) => {
                    if (res.retData) {
                        deleteData()
                    } else {
                        globalPrompt('message', { text: `删除失败`, type: 'success' })
                    }
                })
            } else {
                deleteData()
            }
        }
    }
    //表单计算校验 (计算主单信息与配件每一项)
    const formComputeRule = (mode: string): boolean => {
        let goods = mode === 'edit' ? detailDataSource : detailAddList
        let { totalAll } = mode === 'edit' ? editDesc : addDesc
        totalAll = +formatNum(totalAll) //采购总金额
        let goodsTotal: number = 0
        goods.forEach((item) => {
            let { amount } = item as { amount: number }
            goodsTotal += amount
        })
        if (+formatNum(goodsTotal) !== totalAll) {
            message.warning(`详情采购总金额${+formatNum(goodsTotal)}与表单采购总金额不符`)
            return false
        }
        let goodsNoNum = goods.filter(item => (item.num as number) < 0 || (item.price as number) < 0).map(list => list.materialCode)
        if (goodsNoNum.length > 0) {
            message.warning(`详情${goodsNoNum}的采购数量或采购单价不可小于0！`);
            return false;
        }
        return true
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: IPurchasePoFields) => {
        try {
            // return console.log(detailAddList)
            let newParams = {
                ...params,
                details: detailAddList,
                createUser: user.username,
                // ...shopAndOrg,
                // ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await purchasePoService.insert(newParams)
            setSaveLoading(false)
            return retData
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: IPurchasePoFields) => {
        try {
            let newParams = {
                ...params,
                details: detailDataSource,
                updateUser: user.username,
                // ...shopAndOrg,
                ...sourceAppOrBranch,
            }
            setSaveLoading(true)
            let { retData } = await purchasePoService.update(newParams)
            setSaveLoading(false)
            return retData
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //转销售单
    const insertSaleDetail = useLockFn(async (params: IPurchasePoFields) => {
        // return console.log(detailDataSource)
        let newParams = {
            ...params,
            // details: detailDataSource,
            createUser: user.username,
            // ...shopAndOrg,
            ...sourceAppOrBranch,
        }
        let { retData } = await purchasePoService.transfer(newParams)
        message.success('转接成功')
        return retData
    })
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type: string) => {
        setDetailAddForm(initForm)
        setDetailAddList([])
    }
    const resetEditCatch = async (type: string) => {
        setDetailEditForm({})
        setDetailDataSource([])
    }
    const downloadTpl = async () => {
        let result = await purchasePoService.downloadTpl()
        convertRes2Blob(result)
    }
    const warehousing = useLockFn(async () => {
        let { id, purchaseCode } = detailEditForm
        let paramas = {
            id,
            purchaseCode,
            storekeeper: user.username,
        }
        let { retData } = await purchasePoService.warehousing(paramas)
        return retData
    })
    const onSettle = useLockFn(async (params: object) => {
        let { retData } = await purchasePoService.settle(params)
        return retData
    })
    const supplementInsert = async (params: IPurchasePoFields) => {

        let newParams = {
            ...params,
            details: detailAddList,
            createUser: user.username,
            // ...shopAndOrg,
            ...sourceAppOrBranch,
        }
        let { retData } = await purchasePoService.supplementInsert(newParams)
        return retData
    }
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<IStockStatisticDetail>({})
    const [supplierHistoryVisible, setSupplierHistoryVisible] = useState<boolean>(false) //消费记录展示
    const [supplierHistoryModel, setSupplierHistoryModel] = useState<{ supplierName: string }>({ supplierName: '' }) //消费记录参数
    return {
        // data
        addModalVisible,
        addLoading,
        settleVisible,
        changeSaleDrawer,
        wsConfirmModal,
        registerModal,
        initPgCfg,
        detailAddForm,
        detailAddList,
        detaiAddDataRow,
        addDesc,
        detailLookForm,
        detailLookList,
        lookDesc,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailEditForm,
        editDesc,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        detaiAddDataRowKeys,
        addTempShelfModal,
        // model
        setAddTempShelfModal,
        setAddModalVisible,
        setSettleVisible,
        serChangeSaleDrawer,
        setWsConfirmModal,
        setRegisterModal,
        setDetailAddForm,
        setDetailAddList,
        setDetaiAddDataRow,
        setAddDesc,
        setDetailLookForm,
        setDetailLookList,
        setLookDesc,
        setDetailDataSource,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailEditForm,
        setEditDesc,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetWorkloadData,
        workloadData,
        transformsToPoDetailList,
        detailDetailList,
        insertDetail,
        editDetail,
        resetAddCatch,
        resetEditCatch,
        setDetaiAddDataRowKeys,
        downloadTpl,
        modelScreenMethod,
        warehousing,
        onSettle,
        initForm,
        topButsControl,
        setTopButsControl,
        supplementInsert,
        insertSaleDetail,
        historyVisible,
        setHistoryVisible,
        historyRow,
        setHistoryRow,
        supplierHistoryVisible,
        setSupplierHistoryVisible,
        supplierHistoryModel,
        setSupplierHistoryModel,
        formComputeRule,
        saveLoading,
        setSaveLoading,
        warehouseData, setWarehouseData, transferwarehouseList
    }
})
